import type { ScreenModule } from "../../../app/screen-module";
import { ArtifactDetailPage } from "../ArtifactPages";

export default {
	id: "end-user.artifact-detail",
	path: "/app/artifacts/:artifactId",
	area: "end-user",
	label: "成果物プレビュー",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: ArtifactDetailPage,
} satisfies ScreenModule;
